import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './chevron.scss';

export default function Chevron({ className, direction = 'right' }) {
	return (
		<svg
			className={classnames(className, direction, 'svg chevron')}
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 1792 1792"
		>
			<path d="M1363 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45L531 45q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z" />
		</svg>
	);
}

Chevron.propTypes = {
	className: PropTypes.string,
	direction: PropTypes.string,
};
